import * as React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import useProductName from "brand-customization/useProductName";
import { Link, DocumentTitle, PageHeader, Spinner } from "components/common";
import { Col, Row, ButtonToolbar } from "components/bootstrap";
import DocsHelper from "util/DocsHelper";
import Routes from "routing/Routes";
import { NodesActions, NodesStore } from "stores/nodes/NodesStore";
import ImportLicenseModal from "license/ImportLicenseModal";
import { useStore } from "stores/connect";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import LicenseList from "license/LicenseList/LicenseList";
import useLicenseMutation from "license/hooks/useLicenseMutation";
import ActiveLicenseInformation from "license/ActiveLicenseInformation";
import { LICENSE_SUBJECTS } from "license/constants";
import useLicenseValidityForSubject from "license/hooks/useLicenseValidityForSubject";
import LicenseTrafficEventDefinitionModal from "license/traffic/LicenseTrafficEventDefinitionModal";
const LicenseSectionHeading = styled.h2(
  ({ theme }) => `
  margin-bottom: ${theme.spacings.md};
`
);
const LicensesPage = () => {
  const { t } = useTranslation("enterprise_license");
  const productName = useProductName();
  const [errorMessage, setErrorMessage] = useState(void 0);
  const [verifiedLicense, setVerifiedLicense] = useState(void 0);
  const sendTelemetry = useSendTelemetry("license");
  const { saveLicense, verifyLicense } = useLicenseMutation();
  const {
    data: { valid: isValidLicense }
  } = useLicenseValidityForSubject(LICENSE_SUBJECTS.enterprise);
  const { nodes, clusterId } = useStore(NodesStore);
  useEffect(() => {
    NodesActions.list();
  }, []);
  const onVerifyLicense = (token) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.VALIDATED, {
      app_pathname: "license"
    });
    verifyLicense(token).then(({ license, error_message }) => {
      setErrorMessage(error_message);
      setVerifiedLicense(license);
    });
  };
  const onSaveLicense = (token, callback) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.LICENSE.SAVED, {
      app_pathname: "license"
    });
    saveLicense(token).then(() => {
      callback();
      window.location.reload();
    });
  };
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("license.page.document_title", { productName }) }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("license.page.title", { productName }),
      actions: /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(LicenseTrafficEventDefinitionModal, null), /* @__PURE__ */ React.createElement(
        ImportLicenseModal,
        {
          key: "new-license",
          saveLicense: onSaveLicense,
          verifyLicense: onVerifyLicense,
          errorMessage,
          verifiedLicense
        }
      )),
      documentationLink: {
        title: t("license.page.documentation_link"),
        path: DocsHelper.PAGES.LICENSE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, t("license.page.description", { productName }), !isValidLicense && /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "license.page.get_new_license",
        components: { enterpriseLink: /* @__PURE__ */ React.createElement(Link, { to: Routes.SYSTEM.ENTERPRISE }) }
      }
    ))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(LicenseSectionHeading, null, t("license.page.active_license")), /* @__PURE__ */ React.createElement(ActiveLicenseInformation, null))), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(LicenseSectionHeading, null, t("license.page.installed_licenses")), clusterId && /* @__PURE__ */ React.createElement("p", null, t("license.page.cluster_id", { productName, clusterId })), nodes ? /* @__PURE__ */ React.createElement(LicenseList, null) : /* @__PURE__ */ React.createElement(Spinner, null)))));
};
export default LicensesPage;
